import { Component } from '@angular/core';

@Component({
  selector: 'app-angle-right-icon',
  standalone: true,
  templateUrl: './angle-right-icon.component.html',
})
export class AngleRightIconComponent {}
